import { render, staticRenderFns } from "./SelectIcon.vue?vue&type=template&id=365e990f&scoped=true&"
import script from "./SelectIcon.vue?vue&type=script&lang=ts&"
export * from "./SelectIcon.vue?vue&type=script&lang=ts&"
import style0 from "./SelectIcon.vue?vue&type=style&index=0&id=365e990f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365e990f",
  null
  
)

export default component.exports